import $ from 'jQuery';

import submitForm from './modules/submit-form';
import cookies from './modules/cookies';
import jakte from './modules/jakte';
import sentry from './modules/sentry';
import CarouselSlider from './modules/carousel-slider';
import Header from './modules/header';
import Formstyler from './modules/formstyler';
import ScrollTo from './modules/scroll-link';

import 'styles/less/application';

$(document).ready(() => {
  cookies.init();
  sentry.init();
  jakte.init();
  submitForm.init();
  CarouselSlider.init();
  Header.init();
  Formstyler.init();
  ScrollTo.init();
});



// WEBPACK FOOTER //
// ./src/static/js/main.js